import React from 'react';
import { Building2, LogOut, ChevronRight } from 'lucide-react';

export default function CompanySelector({ user, companies, onSelect, onLogout }) {
  // Only show companies this user has access to
  const availableCompanies = companies.filter(c => user.companies.includes(c.id));

  return (
    <div className="min-h-screen bg-green-50 p-6 md:p-12">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-12">
          <div>
            <h1 className="text-3xl font-extrabold text-green-900">Olá, {user.name}</h1>
            <p className="text-green-600 text-lg mt-1 font-medium">Selecione a empresa para gerir:</p>
          </div>
          <button 
            onClick={onLogout}
            className="flex items-center gap-2 text-green-800 hover:text-red-700 font-bold text-lg"
          >
            <LogOut size={24} /> Sair
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {availableCompanies.map(company => (
            <button
              key={company.id}
              onClick={() => onSelect(company)}
              className="group bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl border border-transparent hover:border-green-300 transition-all text-left flex items-center justify-between"
            >
              <div className="flex items-center gap-6">
                <div className="w-16 h-16 bg-green-100 group-hover:bg-green-800 text-green-800 group-hover:text-white rounded-2xl flex items-center justify-center transition-colors">
                  <Building2 size={32} />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-green-900">{company.name}</h2>
                  <p className="text-green-500 font-medium">Gestão Interna Ativa</p>
                </div>
              </div>
              <ChevronRight className="text-green-300 group-hover:text-green-800 group-hover:translate-x-2 transition-all" size={32} />
            </button>
          ))}
        </div>
        
        {availableCompanies.length === 0 && (
          <div className="text-center py-20 bg-white rounded-3xl shadow-inner border-2 border-dashed border-green-200">
            <p className="text-green-600 text-xl">Não tem acesso a nenhuma empresa.</p>
            <p className="text-green-400 mt-2">Contacte o administrador da plataforma.</p>
          </div>
        )}
      </div>
    </div>
  );
}

